"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMs = getMs;

var _constants = require("../constants");

function getMs(interval) {
  var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var intervalValue = _constants.IntervalMap[interval];
  var ms = 1000;

  if (intervalValue >= _constants.IntervalMap[_constants.Interval.MINUTES]) {
    ms *= 60;
  }

  if (intervalValue >= _constants.IntervalMap[_constants.Interval.HOURS]) {
    ms *= 60;
  }

  if (intervalValue >= _constants.IntervalMap[_constants.Interval.DAYS]) {
    ms *= 24;
  }

  ms *= unit;
  return ms;
}